function t(t,s){const a=this;a.params.cssMode||a.$wrapperEl.transition(t),a.emit("setTransition",t,s)}export{t as default};
//# sourceMappingURL=setTransition.js.map
